import { Brick, registerBrick } from 'olympe';
import { format } from 'date-fns';
export default class CompletionDateMassUpload extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} ctagCompletionDate
     * @param {*} qaInFactoryCompletionDate
     * @param {*} sqaCompletionDate
     * @param {*} workflowState
     * @param {function()} forwardEvent
     * @param {function(*)} setIsDateBefore
     * @param {function(*)} setSelectedDate
     * @param {function(*)} setWarningLabel
     */
    update($, [ctagCompletionDate, qaInFactoryCompletionDate, sqaCompletionDate, workflowState], [forwardEvent, setIsDateBefore, setSelectedDate,setWarningLabel]) {
        //validation for past date 
        const currentDate = new Date();
        const currentFormattedDate = format(currentDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

        //convert the datetime into corrected date time format
        const ctagDate = new Date(ctagCompletionDate)
        const ctagDueDate = ctagDate.toISOString()

        const qaDate = new Date(qaInFactoryCompletionDate)
        const qaDueDate = qaDate.toISOString()

        const sqaDate = new Date(sqaCompletionDate)
        const sqaDueDate = sqaDate.toISOString()

        //validation for ctag,qa and sqa completion date 
        if (ctagDueDate && ctagDueDate > currentFormattedDate && workflowState === "CTAG acceptance") {
            setIsDateBefore(false)
            setSelectedDate(ctagDueDate)
            setWarningLabel(true)
        } else if (qaDueDate && qaDueDate > currentFormattedDate && workflowState === "SQA_QA factory acceptance 1") {
            setIsDateBefore(false)
            setSelectedDate(qaDueDate)
            setWarningLabel(true)

        } else if (sqaDueDate && sqaDueDate > currentFormattedDate && workflowState === "SQA_QA factory acceptance 2") {
            setIsDateBefore(false)
            setSelectedDate(sqaDueDate)
            setWarningLabel(true)
      
        } else {
            setIsDateBefore(true)
            setSelectedDate()
            setWarningLabel(false)

        }
        forwardEvent();
    }
}

registerBrick('019a6c88a7c0641f11e6', CompletionDateMassUpload);
